import { jewlr_t } from "helpers/application"

export const createsomethingSpecial = () => [
  {
    btn: "Shop Now",
    image: "create_something_special/best-sellers",
    link: "/best-sellers",
    textPosition: "left",
    title: "Best Sellers",
  },
  {
    btn: "Shop Now",
    image: "create_something_special/jewelry-for-her",
    link: `/${jewlr_t("terms.jewelry")}-for-her`,
    textPosition: "right",
    title: `${jewlr_t("terms.Jewelry")} For Her`,
  },
  {
    btn: "Shop Now",
    image: "create_something_special/jewelry-for-him",
    link: `/${jewlr_t("terms.jewelry")}-for-him`,
    textPosition: "left",
    title: `${jewlr_t("terms.Jewelry")} For Him`,
  },
  {
    btn: "Shop Now",
    image: "create_something_special/whats-new",
    link: "/new-items",
    textPosition: "right",
    title: "What’s New",
  },
]
